import React, { useCallback, useEffect, useState } from "react";

import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "../../navigation/Sidebar/Sidebar";
import Navbar from "../../navigation/NavBar/NavBar";

export default function BaseLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const closeSidebar = useCallback(() => setSidebarOpen(false), []);
  const { pathname } = useLocation();

  // Back/Forward navigation bypasses the drawer's own links, so close it on every page change.
  useEffect(() => {
    setSidebarOpen(false);
  }, [pathname]);

  return (
    <div className="flex h-screen bg-slate-50 overflow-hidden">
      <Sidebar open={sidebarOpen} onClose={closeSidebar} />
      <div className="flex flex-1 min-w-0 flex-col">
        <Navbar menuOpen={sidebarOpen} onMenuClick={() => setSidebarOpen(true)} />
        {/* `relative`: what is positioned inside the pages (KaTeX's hidden MathML, sr-only texts) stays in <main>'s
            scroll; otherwise it is placed against the whole document, which then scrolls too (a second scrollbar). */}
        <main className="relative flex-1 min-h-0 p-4 lg:p-6 bg-slate-50 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
